import React, { Component } from 'react';

import FormInput from '../../Fields/FormInput.js'
import { getTranslation } from '../../Utilities/GetTranslation.js'
import { postLoginExtranet } from '../../Api/Register.js';

declare var globalSns;

class ExtranetLogIn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      txtSeqOrg: "",
      txtSiteNam: "",
      txtUserPassword: ""
    };

    this.login = this.login.bind(this);
    this.register = this.register.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
  }

  componentWillMount() {
    // Automatically login when impersonation is set for an extranet user
    if (globalSns.impersonateType === 2) {
      this.loginWithToken();
    }
  }   

  handleValueChange(e) {
    this.setState({
      [e.target.id]: e.target.value
    });         
  }

  login() {
    postLoginExtranet(this.state.txtSiteNam, this.state.txtUserPassword, false, (data) => {
      if (data) {
        this.props.onLoginSucceeded();
      } else {
        this.setState({
          loginerror: true
        });
      }
    });
  }

  loginWithToken() {
    postLoginExtranet(globalSns.impersonateUser, globalSns.impersonateToken, true, (data) => {
      if (data) {
        this.props.onLoginSucceeded();
      } else {
        this.setState({
          loginerror: true
        });
      }
    });
  }

  register() {
    this.props.onRegisterRequest();
  }

  render() {
    return (
      <div className="col-md-6">
        {
          (this.state.loginerror) ?
            <span className="ErrorLabel">{getTranslation("sns.webparts.register.login.error")}</span> : ""
        }
        <h2><i className="fa fa-building"></i>{getTranslation("sns.webparts.register.titleloginextranet")}</h2>
        <h3>{getTranslation("sns.webparts.register.extranet")}</h3>
        <h4>{getTranslation("sns.general.or")} <a href="# " onClick={this.register}>{getTranslation("sns.webparts.register.registerextranet")}</a></h4>
        <div className="EditingFormTable table">
          <div className="legend">
              <FormInput id="txtSiteNam" 
                    text={getTranslation("sns.webparts.register.sitenam")}
                    required={true}
                    value={this.state.txtSiteNam} 
                    autoComplete="username"
                    onChange={this.handleValueChange} 
                    onEnter={this.login} />
              <FormInput id="txtUserPassword" 
                    text={getTranslation("sns.webparts.register.password")}
                    required={true}
                    type="password"
                    value={this.state.txtUserPassword} 
                    autoComplete="current-password"
                    onChange={this.handleValueChange} 
                    onEnter={this.login} />                    
              <div className="tr text-right">
                  <input type="button" value={getTranslation("sns.webparts.register.login")} onClick={this.login} id="loginbutton" className="FormButton btn btn-primary next" />
              </div>
              <div className="tr text-right">
                  <a href={globalSns.resetPasswordUrl + "extranet"}>{getTranslation("sns.webparts.register.resetpassword")}</a>
              </div>              
          </div>        
        </div>
      </div>
    );
  }
}

export default ExtranetLogIn;


// WEBPACK FOOTER //
// ./src/Components/Extranet/ExtranetLogIn.js